
export type ProjectResponseBasicInfoVisibility = typeof ProjectResponseBasicInfoVisibility[keyof typeof ProjectResponseBasicInfoVisibility];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectResponseBasicInfoVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  LINK_ONLY: 'LINK_ONLY',
} as const;
